module.exports = __webpack_public_path__ + "img/report-logo.dac5faf3.png";